import React, { useState, useRef } from "react";
import { useAuth } from "../context/AuthContext";
import { useToast } from "../context/ToastContext";
import { useNavigate } from "react-router-dom";
import Captcha from "./shared/Captcha";

const Login = () => {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const { success, error } = useToast();
  const navigate = useNavigate();
  const captchaRef = useRef(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate CAPTCHA
    if (!captchaRef.current || !captchaRef.current.validate()) {
      error(
        "CAPTCHA verification failed. Please complete the reCAPTCHA verification."
      );
      return;
    }

    // Get reCAPTCHA token
    const recaptchaToken = captchaRef.current?.getValue();

    setLoading(true);

    try {
      const result = await login(
        formData.username,
        formData.password,
        recaptchaToken
      );

      if (result.success) {
        success("Login successful! Redirecting to dashboard...");
        // Reset CAPTCHA after successful login
        if (captchaRef.current) {
          captchaRef.current.reset();
        }
        setTimeout(() => {
          navigate("/dashboard");
        }, 1000);
      } else {
        error(result.message);
        // Reset CAPTCHA on login failure
        if (captchaRef.current) {
          captchaRef.current.reset();
        }
      }
    } catch (err) {
      error("An unexpected error occurred. Please try again.");
      // Reset CAPTCHA on error
      if (captchaRef.current) {
        captchaRef.current.reset();
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h1>Hospital Admin Login</h1>
          <p>Sign in to access the dashboard</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              placeholder="Enter your username"
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Enter your password"
              className="form-input"
            />
          </div>

          <Captcha ref={captchaRef} />

          <button
            type="submit"
            disabled={loading}
            className={`login-btn ${loading ? "loading" : ""}`}
          >
            {loading ? "Signing In..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
